import { iconMap } from '../Home/Card';
import './Sidebar.css';
import { optionsMap } from './sideBarSubMenus';
import { IconChevronDown, IconPlus, IconArrowLeft } from '@tabler/icons-react';
import { useState } from 'react';
import { useContext } from 'react';
import EntityProjectsContext from '../../context/EntityProjects.context';
import { useDispatch } from 'react-redux';

const Sidebar = ({
    logoURL,
    color,
    projects,
    onClick,
    onClickLogo,
    menuClicked,
    activeSubMenu,
    setActiveSubMenu,
    indicatorsTabs,
    subMenus = optionsMap
}) => {
    const { setPageToRender } = useContext(EntityProjectsContext);
    const dispatch = useDispatch();

    return (
        <div className="sidebar-container">
            <div className="image-container c-pointer" onClick={onClickLogo}>
                <img className="logo-sidebar" src={logoURL} alt="logo" />
            </div>
            <div className="divider" />
            <div className="sidebar-content">
                {projects.map((item, index) => {
                    return (
                        item.show && (
                            <SidebarItem
                                onClick={() => onClick(item)}
                                color={color}
                                key={index}
                                title={item.title}
                                description={item.description}
                                isActive={
                                    menuClicked &&
                                    menuClicked.title === item.title
                                }
                                activeSubMenu={activeSubMenu}
                                setActiveSubMenu={setActiveSubMenu}
                                indicatorsTabs={
                                    item.title === 'Indicadores'
                                        ? indicatorsTabs
                                        : []
                                }
                                subMenus={subMenus}
                            />
                        )
                    );
                })}
            </div>
            <div className="divider" />
            <div
                className="sidebar-back-button"
                onClick={() => {
                    setPageToRender('goback')
                    dispatch({ type: 'UPDATE_SESSION', key: 'pdc_project_friendly_url', value: null });
                    dispatch({ type: 'UPDATE_SESSION', key: 'pdc_project_id', value: null });
                }}
            >
                <IconArrowLeft style={{ margin: 0 }} size={20} />
                <p>Ver outros projetos</p>
            </div>
        </div>
    );
};

export default Sidebar;

const SidebarItem = ({
    title,
    onClick,
    color,
    isActive,
    activeSubMenu,
    setActiveSubMenu,
    indicatorsTabs = [],
    subMenus = optionsMap
}) => {
    const selectedIcon = iconMap[title] ?? <IconPlus fontSize={20} />;
    const options = indicatorsTabs.length
        ? [...indicatorsTabs]
        : subMenus[title] || [];

    const [isHovered, setIsHovered] = useState(false);
    return (
        <div style={{ borderRadius: '8px' }}>
            <div
                onClick={() => {
                    onClick();
                    setActiveSubMenu(
                        options && options[0] ? options[0].value : ''
                    );
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                className={`sidebar-item ${isActive ? 'sidebar-item-is-active' : ''
                    }`}
                style={(isActive || isHovered) ? { backgroundColor: color } : {}}
            >
                <div
                    className="d-flex align-items-center"
                    style={{ gap: '10px' }}
                >
                    <div>{selectedIcon}</div>
                    <p>{title}</p>
                </div>

                {isActive && options.length > 0 && (
                    <div className="align-self-end">
                        <IconChevronDown />
                    </div>
                )}
            </div>
            {isActive &&
                options &&
                options.length > 0 &&
                options.map((option, index) => (
                    <div
                        key={index}
                        className={`sidebar-submenu ${activeSubMenu === option.value
                            ? 'sidebar-submenu-active'
                            : ''
                            }`}
                        onClick={() => setActiveSubMenu(option.value)}
                    >
                        <p>{option.title}</p>
                    </div>
                ))}
        </div>
    );
};
